import "./gce-o.css";
import Filters from "../../components/reports/Filters";
import Breadcrumbs from "../../components/reports/Breadcrumbs";
import { useSchoolExamReports } from "../../hooks/useSchoolExamReports";
import SchoolExamReportContent from "../../components/reports/SchoolExamReportContent";
import { ReportsService } from "../../services/reports.service";
import { useState } from "react";

const SchoolExamReports = () => {
  const {
    examTypes,
    selectedExamTypeIds,
    selectedExamTypes,
    registrationStatus,
    paymentStatus,
    registrationData,
    error,
    isALSelected,
    setRegistrationStatus,
    setPaymentStatus,
    handleExamTypeSelection,
    schoolId,
    loading,
  } = useSchoolExamReports();

  const [isDownloading, setIsDownloading] = useState(false);

  const downloadPDFBackend = async () => {
    if (selectedExamTypeIds.length === 0 || !schoolId) return;

    setIsDownloading(true);
    try {
      const blob = await ReportsService.downloadSchoolExamReportPdf({
        exam_type_ids: selectedExamTypeIds,
        school_id: schoolId,
      });

      const fileName = `school-exam-report-${selectedExamTypeIds.join(",")}-${new Date().toISOString()}.pdf`;

      // Create a link element to trigger the download
      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.parentNode?.removeChild(link);
    } catch (error) {
      console.error("Error downloading PDF:", error);
      alert("Failed to download PDF. Please try again.");
    } finally {
      setIsDownloading(false);
    }
  };

  // Compute whether download button should be disabled
  const isDownloadDisabled =
    loading ||
    selectedExamTypes.length === 0 ||
    registrationData?.exam_registration?.payment_status !== "paid";

  const breadcrumbs = [
    { label: "Home", to: "/" },
    { label: "Reports", to: "/reports" },
    { label: "School Exam Reports", to: "/reports/school-exam-reports" },
  ];

  const buttons = [
    // {
    //   label: "Print PDF (Browser)",
    //   onClick: downloadPDFPrint,
    //   disabled: isDownloadDisabled,
    // },
    {
      label: isDownloading ? "Downloading..." : "Download Receipt (PDF)",
      onClick: downloadPDFBackend,
      disabled: isDownloadDisabled || isDownloading,
    },
  ];

  return (
    <>
      <Breadcrumbs breadcrumbs={breadcrumbs} buttons={buttons} />

      <Filters
        examTypes={examTypes}
        selectedExamTypeIds={selectedExamTypeIds}
        registrationStatus={registrationStatus}
        paymentStatus={paymentStatus}
        error={error}
        setRegistrationStatus={setRegistrationStatus}
        setPaymentStatus={setPaymentStatus}
        handleExamTypeSelection={handleExamTypeSelection}
      />

      {/* Main Form section */}
      <SchoolExamReportContent
        registrationData={registrationData}
        selectedExamTypes={selectedExamTypes}
        isALSelected={isALSelected}
        examTypes={examTypes}
        selectedExamTypeIds={selectedExamTypeIds}
      />
    </>
  );
};

export default SchoolExamReports;
